import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import ClientDetail from './Client';
import ClientDepartment from './ClientDepartment';
import ClientStaffDetail from './ClientStaff';
const ClientDetailsCard = ({ charterDetails,route }) => {
   if (charterDetails) {
        const { client, clientDepartment, clientStaff } = charterDetails;
        return (<Container><Row>
            {client ? <Col><ClientDetail route={route} client={client} clientDepartment={clientDepartment} /></Col> : null}
            {clientDepartment ? <Col> <ClientDepartment route={route}  clientDepartment={clientDepartment} clientStaff={clientStaff} /> </Col>: null}
            {clientStaff ? <Col><ClientStaffDetail route={route}  clientStaff={clientStaff} /> </Col>: null}
       
        </Row>
        </Container>)
    }
    return null;
};
 
export default ClientDetailsCard; 